var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWelldone = function SvgWelldone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#040512",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.088 13.547 3.24-6.822a2.54 2.54 0 0 1 1.73.661c.458.425.717 1.002.719 1.605l-.708 3.163 5.323-.146c.236-.003.47.042.686.132.216.089.408.22.563.386.155.165.27.36.336.57.067.211.083.433.048.65l-1.107 6.818a1.5 1.5 0 0 1-.554.928c-.298.237-.68.366-1.072.363l-9.185.022m-.02-8.33.02 8.33m-.02-8.33-2.442.006a1.7 1.7 0 0 0-1.15.446c-.305.285-.476.67-.475 1.072l.012 5.3c.001.402.174.787.48 1.07s.72.442 1.153.441l2.442-.005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4884F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.175 4.093 11.965 2M16.83 3.097 14.949 5.4M16.78 7.858l2.093-.21"
  })));
};
export default SvgWelldone;